import React from "react"

const VARIANTS = {
  primary: "ui-btn ui-btn--primary",
  secondary: "ui-btn ui-btn--secondary",
  accent: "ui-btn ui-btn--accent",
  outline: "ui-btn ui-btn--secondary",
}

export function Button({
  variant = "primary",
  size,
  full = false,
  className = "",
  type = "button",
  children,
  ...props
}) {
  const classes = [
    VARIANTS[variant] || VARIANTS.primary,
    size === "sm" ? "ui-btn--sm" : null,
    full ? "ui-btn--full" : null,
    className,
  ]
    .filter(Boolean)
    .join(" ")

  return (
    <button type={type} className={classes} {...props}>
      {children}
    </button>
  )
}

export default Button
